import z from "zod";
import { ZodSchema } from "@validation/utils/schemaUtils";
import { locationSelectOptionSchema } from "view/locations/utils/location.schema";
import { shipSelectOptionSchema } from "view/ships/utils/ship.schema";

export const mapShipRouteSchema = z.object({
	ship: ZodSchema.requiredField(shipSelectOptionSchema),
	time: ZodSchema.requiredField(z.number()),
	location: ZodSchema.requiredField(locationSelectOptionSchema),
});

export type MapShipRouteSchemaInput = z.input<typeof mapShipRouteSchema>;
export type MapShipRouteSchemaOutput = z.output<typeof mapShipRouteSchema>;

export const mapLocationRouteSchema = z.object({
	from: ZodSchema.requiredField(locationSelectOptionSchema),
	to: ZodSchema.requiredField(locationSelectOptionSchema),
});

export type MapLocationRouteSchemaInput = z.input<typeof mapLocationRouteSchema>;
export type MapLocationRouteSchemaOutput = z.output<typeof mapLocationRouteSchema>;

export const mapSimulatorSchema = z.object({
	ship: ZodSchema.requiredField(shipSelectOptionSchema),
	course: ZodSchema.requiredField(z.number()),
	speed: ZodSchema.requiredField(z.number()),
	timestamp: z.number().nullable(),
	token: z.string().min(1),
});

export type MapSimulatorSchemaInput = z.input<typeof mapSimulatorSchema>;
export type MapSimulatorSchemaOutput = z.output<typeof mapSimulatorSchema>;


export const mapShipHistorySchema = z.object({
	hourWindow: z.number(),
	from: ZodSchema.requiredField(z.number()),
	to: ZodSchema.requiredField(z.number()),
});

export type MapShipHistorySchemaInput = z.input<typeof mapShipHistorySchema>;
export type MapShipHistorySchemaOutput = z.output<typeof mapShipHistorySchema>;
